import {
  DELETE_USER_START,
  DELETE_USER_SUCCESS,
  DELETE_USER_ERROR,
} from 'constants/action-types/user/deleteUser';
import userState from '../../initial-states/user';

export default (state = userState, { type, payload }) => {
  switch (type) {
    case DELETE_USER_START:
      return {
        ...state,
        deleteUser: {
          ...state.deleteUser,
          loading: true,
        },
      };
    case DELETE_USER_ERROR:
      return {
        ...state,
        deleteUser: {
          ...state.deleteUser,
          error: payload,
          loading: false,
        },
      };

    case DELETE_USER_SUCCESS:
      return {
        ...state,
        deleteUser: {
          ...state.deleteUser,
          message: payload,
          error: {},
          loading: false,
        },
      };
    default:
      return null;
  }
};
